import React, { useEffect } from 'react';
import '../styles/ScrollableImages.css';
import { Arrow } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

function ScrollableImages(props) {
    const images = props.images;
    const closeScrollableImages = props.closeScrollableImages;
    const imageClick = props.imageClick;

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeScrollableImages();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [closeScrollableImages]);

    return (
        <div className="scrollable-images-outer-container bg-colour-white">
            <div className="scrollable-images-exit-container">
                <div 
                    className="text-button button-row gap-small bg-colour-white scrollable-image-back-button"
                    onClick={() => closeScrollableImages()}
                >
                    <Arrow
                        className=""
                        fill={colour.gray06}
                    />
                    <span className="body-bold colour-primary">
                        Back
                    </span>
                </div>
            </div>
            <div className="scrollable-images-container">
                {
                    images.map((item, index) =>
                        <img
                            key={index}
                            src={item}
                            alt="product"
                            className="scrollable-image cursor-pointer"
                            onClick={() => imageClick(index)}
                        />
                    )
                }
            </div>
        </div>
    )
};

export default ScrollableImages;